<template>
  <v-col cols="12" md="12" sm="12">
    <v-dialog
      v-model="detalleLogisticaDialog"
      max-width="950px"
    >
        <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Detalle Recepción</span>
          <v-btn
            text
            color="primary"
            :disabled="!detalleLogistica"
            @click="imprimirDetalleLogistica"
          >
            Imprimir PDF
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-progress-linear v-if="loadingDetalleLogistica" indeterminate color="primary"></v-progress-linear>
          <template v-else-if="detalleLogistica">
            <v-row>
              <v-col cols="12" md="6"><b>Fecha Recepción:</b> {{ detalleLogistica.fechaRecepcion || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Fecha Arribo:</b> {{ detalleLogistica.fechaArribo || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Hora Fin:</b> {{ detalleLogistica.horaFin || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Tipo Movimiento:</b> {{ detalleLogistica.tipoMovimiento || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Almacén:</b> {{ detalleLogistica.almacen || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Subalmacén:</b> {{ detalleLogistica.subalmacen || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Área:</b> {{ detalleLogistica.area || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Tipo Almacén:</b> {{ detalleLogistica.tipoAlmacen || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Cliente:</b> {{ detalleLogistica.cliente || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Turno:</b> {{ detalleLogistica.turno || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Operador:</b> {{ detalleLogistica.operador || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Montacarguista:</b> {{ detalleLogistica.montacarguista || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Placas:</b> {{ detalleLogistica.placas || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Sello:</b> {{ detalleLogistica.sello || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Línea Transporte:</b> {{ detalleLogistica.lineaTransporte || 'N/A' }}</v-col>
              <v-col cols="12" md="6"><b>Artículo:</b> {{ (detalleLogistica.codigoArticulo ? `[${detalleLogistica.codigoArticulo}] - ` : '') + (detalleLogistica.articulo || 'N/A') }}</v-col>
              <v-col cols="12" md="6"><b>Cantidad:</b> {{ detalleLogistica.cantidad }} {{ detalleLogistica.unidad || '' }}</v-col>
              <v-col cols="12"><b>Descripción:</b> {{ detalleLogistica.descripcion || 'N/A' }}</v-col>
              <v-col cols="12">
                <b>Proveedores:</b>
                {{
                  (detalleLogistica.proveedores && detalleLogistica.proveedores.length)
                    ? detalleLogistica.proveedores.join(', ')
                    : 'N/A'
                }}
              </v-col>
            </v-row>

            <div class="mt-3"><b>Etiquetas</b></div>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Envases</th>
                  <th>Volumen</th>
                  <th>Cantidad</th>
                  <th>Folio</th>
                  <th>Caducidad</th>
                  <th>Semana Frescura</th>
                  <th>Lote</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(etiqueta, idx) in (detalleLogistica.etiquetas || [])" :key="idx">
                  <td>{{ etiqueta.envases }}</td>
                  <td>{{ etiqueta.volumen }}</td>
                  <td>{{ etiqueta.cantidad }}</td>
                  <td>{{ etiqueta.folio || 'N/A' }}</td>
                  <td>{{ etiqueta.caducidad || 'N/A' }}</td>
                  <td>{{ textoSemanaFrescuraEtiqueta(etiqueta) }}</td>
                  <td>{{ etiqueta.lote || 'N/A' }}</td>
                </tr>
                <tr v-if="!(detalleLogistica.etiquetas || []).length">
                  <td colspan="7" class="text-center">No hay etiquetas</td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="detalleLogisticaDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="descargarDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text class="text-center">
          <lottie :options="checkOptions" :height="200" :width="200"/>
          <a class="headline" target="__blank" :href="buildApiUrl('/Inventario/DescargarQR/'+ficheroDescargar)+'?access_token='+token"><v-icon color="primary" large>mdi-download</v-icon> Descargar Códigos QR</a>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="ficheroDescargar = ''; descargarDialog = false; ">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" class="pt-0 d-flex align-center">
        <download-btn
          v-if="permisoVista('movimientos', 'r')"
          color="blue darken-1"
          text
          @click="descargarReporte"
          label="Descargar Reporte de<br>Resumen de Movimientos XLSX"
        ></download-btn>
        <download-btn
          v-if="permisoVista('movimientos', 'r')"
          color="blue darken-1"
          text
          @click="descargarReportePDF"
          label="Descargar Reporte de<br>Resumen de Movimientos PDF"
        ></download-btn>
        <v-btn
          v-if="trazabilidadInventario"
          text
          color="primary"
          class="ml-auto"
          style="font-size: 12px !important"
          @click="$emit('showDialogMovimientoAlmacenes')"
        >
          Nuevo Movimiento<br>entre Almacenes
        </v-btn>
        <v-btn
          v-if="!trazabilidadInventario"
          text
          color="primary"
          style="font-size: 12px !important"
          @click="$emit('showDialogMovimientoAlmacenessinQR')"
        >
          Nuevo Movimiento<br>entre Almacenes sin QR
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headersFiltrados"
      :items="items"
      :loading="loading"
      :sort-by="['fecha']"
      :sort-desc="[true]"
      :page.sync="page"
      :item-class="rowSospechoso"
    >
      <template v-slot:[`item.icono`]="{ item }">
        <v-icon v-if="item.idTipoMovimiento==6" :color="colores[0]" small>{{'mdi-'+iconos[0]}}</v-icon>
        <v-icon v-else-if="item.idTipoMovimiento==7" color="orange" small>{{'mdi-swap-horizontal-bold'}}</v-icon>
        <v-icon v-else :color="colores[item.idTipoMovimiento -1]" small>{{'mdi-'+iconos[item.idTipoMovimiento -1]}}</v-icon>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{item.fechaLabel}}
      </template>
      <template v-slot:[`item.numerodeFactura`]="{ item }">
        {{item.numerodeFactura == null ? 'N/A' : item.numerodeFactura}}
      </template>
      <template v-slot:[`item.articulo`]="{ item }">
        {{
          item.codigoArticulo!=null
          ? `[${item.codigoArticulo}] - ${item.articulo}`
          : `${item.articulo}`
        }}
      </template>
      <template v-slot:[`item.cantidad`]="{ item }">
        {{item.cantidad%1!=0?item.cantidad.toFixed(4):item.cantidad}} {{item.unidad}}
      </template>
      <template v-slot:[`item.trabajoOrden`]="{ item }">
        {{item.trabajoOrden != null ? item.trabajoOrden: (item.idTipoMovimiento == 1)?'N/D':'N/A' }}
      </template>
      <template v-slot:[`item.articuloProducir`]="{ item }">
        {{item.articuloProducir != null ? item.articuloProducir: (item.idTipoMovimiento == 1)?'N/D':'N/A' }}
      </template>
      <template v-slot:[`item.cliente`]="{ item }">
        {{ item.cliente != null ? item.cliente: item.idTipoMovimiento == 1 ? nombreEmpresa : 'N/A'}}
      </template>
      <template v-slot:[`item.sospechoso`]="{ item }">
        {{!!item.sospechoso?'Si':'No'}}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip v-if="permisoVista('movimientos', 'r')"  bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              v-show="validarDescarga(item) || tieneDetalleLogistica(item)"
              small
              class="mr-2"
              @click="downloadItem(item)"
            >
              mdi-download
            </v-icon>
          </template>
          <span class="white--text">Descargar Etiquetas</span>
        </v-tooltip>


        <v-tooltip v-if="permisoVista('movimientos', 'c') && pendienteEnlaceLogistica(item)" bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              small
              class="mr-2"
              :class="estaEnlazandoLogistica(item) ? 'mdi-spin' : ''"
              @click="enlazarRecepcionLogistica(item)"
            >
              {{ estaEnlazandoLogistica(item) ? 'mdi-loading' : 'mdi-link-plus' }}
            </v-icon>
          </template>
          <span class="white--text">Enlazar elemento</span>
        </v-tooltip>

        <v-tooltip v-if="permisoVista('movimientos', 'r') && tieneDetalleLogistica(item)" bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              small
              class="mr-2"
              @click="verDetalleLogistica(item)"
            >
              mdi-eye
            </v-icon>
          </template>
          <span class="white--text">Ver detalle</span>
        </v-tooltip>

        <v-tooltip v-if="permisoVista('movimientos', 'r') && tieneDetalleLogistica(item)" bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              small
              class="mr-2"
              @click="abrirPdfLogistica(item)"
            >
              mdi-file-pdf-box
            </v-icon>
          </template>
          <span class="white--text">Abrir PDF</span>
        </v-tooltip>

<!-- Botón de logística redundante: "Descargar Etiquetas" (downloadItem) ya enruta a la etiqueta de logística cuando aplica.
        <v-tooltip v-if="permisoVista('movimientos', 'r') && tieneDetalleLogistica(item)" bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              small
              class="mr-2"
              @click="downloadLogisticaQR(item)"
            >
              mdi-download
            </v-icon>
          </template>
          <span class="white--text">Descargar Etiquetas</span>
        </v-tooltip>
        -->
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import axios from "axios"
import { mapState } from "vuex"
import moment from "moment";
import Lottie from 'vue-lottie';
import * as checkData from '@/assets/check.json';
import DownloadBtn from '../../../DownloadBtn.vue';

export default {
  props: {
    validarDescarga: {
      type: Function,
      default: () => false
    }
  },
  components:{
    'lottie': Lottie,
    DownloadBtn
  },
  data: () => ({
    checkOptions: {
      animationData: checkData.default,
      loop:false,
      speeed: 0.5
    },
    page:1,
    iconos:['arrow-left','arrow-right','plus','redo','cached'],
    colores:['red','green','black','orange','brow'],
    items:[],
    loading: false,
    parametros:"",
    headers: [
      {
        text: '',
        value: 'icono',
        width:'2%',
        sortable: false,
      },
      {
        text: 'Fecha',
        value: 'fecha',
        width:'10%',
        align: 'center',
      },
      {
        text: '# Factura',
        value: 'numerodeFactura',
        width:'10%',
        align: 'center',
      },
      {
        text: 'Tipo Movimiento',
        value: 'tipoMovimiento',
        width:'10%',
        align: 'center',
      },
      {
        text: "Almacén",
        align: "center",
        value: "almacen"
      },
      {
        text: "Subalmacén",
        align: "center",
        value: "subalmacen"
      },
      {
        text: 'Artículo',
        value: 'articulo',
        width:'25%',
        align: 'center',
      },
      {
        text: 'Cantidad',
        value: 'cantidad',
        width:'10%',
        align: 'center',
      },
      {
        text: 'Cliente',
        value: 'cliente',
        width:'10%',
        align: 'center',
      },
      {
        text: 'Orden de Trabajo',
        value: 'trabajoOrden',
        width:'11%',
        align: 'center',
      },
      {
        text: 'Artículo Producir',
        value: 'articuloProducir',
        width:'16%',
        align: 'center',
      },
      {
        text: 'Sospechoso',
        value: 'sospechoso',
        align: 'center',
      },
      {
        text: 'Acciones',
        value: 'actions',
        width:'6%',
        align: 'center',
      },
    ],
    ficheroDescargar:"",
    descargarDialog:false,
    detalleLogisticaDialog:false,
    detalleLogistica:null,
    loadingDetalleLogistica:false,
    enlazandoRecepcionesLogistica: [],
  }),
  computed: {
    ...mapState({
      nombreEmpresa: "nombreEmpresa",
      token: "token",
      trazabilidadInventario: "trazabilidadInventario",
      movimientosFactura: "movimientosFactura"
    }),
    apiBase(){
      const base = axios.defaults.baseURL || "";
      return base.endsWith("/") ? base.slice(0, -1) : base;
    },
    headersFiltrados(){
      let headers = [...this.headers];
      if(!this.trazabilidadInventario) headers = headers.filter(h => h.value != 'actions');
      if(!this.movimientosFactura) headers = headers.filter(h => h.value != 'numerodeFactura');
      return headers;
    }
  },
   methods: {
    buildApiUrl(path){
      const normalizedPath = path.startsWith("/") ? path : `/${path}`;
      if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath;
      return `${this.apiBase}${normalizedPath}`;
    },
    textoSemanaFrescuraEtiqueta(etiqueta){
      if (!etiqueta) return 'N/A';
      const inicio = etiqueta.semanaFrescuraInicio;
      const fin = etiqueta.semanaFrescuraFin;
      if (inicio && fin) return `${inicio} - ${fin}`;
      if (inicio) return inicio;
      return 'N/A';
    },
    esRecepcionLogistica(item){
      return item != null && Number(item.idMovimiento) < 0;
    },
    tieneDetalleLogistica(item){
      return this.esRecepcionLogistica(item) || (item != null && Number(item.idRecepcionLogisticaArticulo) > 0);
    },
    pendienteEnlaceLogistica(item){
      return this.esRecepcionLogistica(item) && !!item.pendienteEnlaceLogistica;
    },
    obtenerIdRecepcionLogisticaArticulo(item){
      if(this.esRecepcionLogistica(item)) return Math.abs(Number(item.idMovimiento));
      if(item != null && Number(item.idRecepcionLogisticaArticulo) > 0) return Number(item.idRecepcionLogisticaArticulo);
      return null;
    },
    estaEnlazandoLogistica(item){
      const id = this.obtenerIdRecepcionLogisticaArticulo(item);
      return id != null && this.enlazandoRecepcionesLogistica.includes(id);
    },
    rowSospechoso(item){
      return !!item.sospechoso?'red--text':'black--text';
    },
    getData(parametros){
      this.parametros = parametros;
      this.loading = true;
      this.items = [];
      axios
        .get("/Inventario/Movimientos"+parametros)
        .then((response) => {
          this.page = 1;
          this.loading = false;
          this.items = response.data;
          
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    downloadItem(item){
      // Si el movimiento tiene recepción logística vinculada, se reimprime la etiqueta
      // COMPLETA de logística (con área, turno, cliente, placas, etc.). Si no, la etiqueta
      // normal del movimiento (los campos que no apliquen quedan en N/A, que es correcto).
      if(this.tieneDetalleLogistica(item)){
        this.downloadLogisticaQR(item);
        return;
      }
      axios
      .get("/Inventario/ReimprimirQRCodes/"+item.idMovimiento)
      .then(response => {
        if(response.data != null && response.data.length > 0){
          this.ficheroDescargar = response.data;
          this.descargarDialog = true;
          return;
        }
        this.$notify({
          group: 'inventario',
          title: 'No se generó archivo para descargar',
          type: 'warn',
        });
      })
      .catch(error => {
        this.$notify({
          group: 'inventario',
          title: 'No se pudo generar el QR para descarga',
          type: 'error',
        });
        console.log(error);
      });
    },
    verDetalleLogistica(item){
      const id = this.obtenerIdRecepcionLogisticaArticulo(item);
      if(!id) return;

      this.loadingDetalleLogistica = true;
      axios
      .get("/Inventario/RecepcionLogisticaDetalle/"+id)
      .then(response => {
        this.detalleLogistica = response.data;
        this.detalleLogisticaDialog = true;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingDetalleLogistica = false;
      });
    },
    abrirPdfLogistica(item){
      const id = this.obtenerIdRecepcionLogisticaArticulo(item);
      if(!id) return;
      window.open(this.buildApiUrl('/Inventario/RecepcionLogisticaEtiquetaPdf/'+id)+'?access_token='+this.token,'_blank');
    },
    imprimirDetalleLogistica(){
      if(!this.detalleLogistica) return;
      window.open(this.buildApiUrl('/Inventario/RecepcionLogisticaEtiquetaPdf/'+this.detalleLogistica.idRecepcionLogisticaArticulo)+'?access_token='+this.token,'_blank');
    },
    downloadLogisticaQR(item){
      const id = this.obtenerIdRecepcionLogisticaArticulo(item);
      if(!id) return;
      axios
      .get("/Inventario/ReimprimirQRCodesLogistica/"+id)
      .then(response => {
        if(response.data != null && response.data.length > 0){
          this.ficheroDescargar = response.data;
          this.descargarDialog = true;
          return;
        }
        this.$notify({
          group: 'inventario',
          title: 'No se generó archivo QR de logística',
          type: 'warn',
        });
      })
      .catch(error => {
        this.$notify({
          group: 'inventario',
          title: 'No se pudo obtener el QR de logística',
          type: 'error',
        });
        console.log(error);
      });
    },
    async enlazarRecepcionLogistica(item){
      if(!this.pendienteEnlaceLogistica(item)) return;

      const idRecepcionLogisticaArticulo = this.obtenerIdRecepcionLogisticaArticulo(item);
      if(!idRecepcionLogisticaArticulo || this.enlazandoRecepcionesLogistica.includes(idRecepcionLogisticaArticulo)) return;

      this.enlazandoRecepcionesLogistica.push(idRecepcionLogisticaArticulo);

      try{
        const response = await axios.post("/Inventario/EnlazarRecepcionesLogisticas", {
          IdRecepcionLogisticaArticulo: idRecepcionLogisticaArticulo
        });

        item.pendienteEnlaceLogistica = false;

        const data = response && response.data ? response.data : {};
        const elementos = data.elementosCreados || 0;
        const enlaces = data.enlacesProveedorCreados || 0;
        const movimientos = data.movimientoDetallesCreados || 0;

        this.$notify({
          group: "inventario",
          type: "success",
          title: `Enlace completado. Elementos: ${elementos}, Proveedores: ${enlaces}, Detalles: ${movimientos}`
        });
      }catch(error){
        this.$notify({
          group: "inventario",
          type: "error",
          title: "No se pudo enlazar la fila logística"
        });
        console.log(error);
      }finally{
        this.enlazandoRecepcionesLogistica = this.enlazandoRecepcionesLogistica
          .filter(id => id !== idRecepcionLogisticaArticulo);
      }
    },
    descargarReporte(){
      var datetime = moment().format('YYYYMMDDHHmmss');
      this.$utils.axios.downloadFile("/Inventario/MovimientosExportar"+this.parametros,'GET','resumen-movimientos-'+datetime+'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    },
    descargarReportePDF(){
      var datetime = moment().format('YYYYMMDDHHmmss');
      this.$utils.axios.downloadFile("/Inventario/MovimientosResumenPdf"+this.parametros,'GET','resumen-movimientos-'+datetime+'.pdf','application/pdf');
    },
  }
}
</script>